export const apiBasePath = (() => {
  /* eslint-disable no-restricted-globals*/
  if (location.hostname === "localhost") {
    return `http://${location.hostname}:3000`;
  }
  return `${location.protocol}//api.${location.host}`;
  /* eslint-enable no-restricted-globals*/
})();
